const cloudName = process.env.REACT_APP_CLOUDINARY_NAME || "dqxlte6wf";
const upload_preset = process.env.REACT_APP_UPLOAD_PRESET || "dev-wb";

const UploadImg = async (file) => {
  if (!file) throw new Error("No file selected for upload.");

  console.log("Cloudinary Upload Started...");
  console.log("Cloud Name:", cloudName);
  console.log("Upload Preset:", upload_preset);

  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", upload_preset);

  const response = await fetch(
    `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`,
    {
      method: "POST",
      body: formData,
    }
  );

  const data = await response.json();
  console.log("Cloudinary Response:", data);

  if (!response.ok) {
    console.error("Cloudinary Error:", data);
    throw new Error(data?.error?.message || "Image upload failed");
  }

  console.log(" Image uploaded successfully:", data.secure_url);
  return data.secure_url;
};

export default UploadImg;
